var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Up_Arrow_-_Big",
    "data-name": "Up Arrow - Big",
    d: "M5.392,1.93a1.427,1.427,0,0,1,2.449,0l4.629,8.49a1.263,1.263,0,0,1-1.224,1.816H1.987A1.263,1.263,0,0,1,.763,10.42Z",
    transform: "translate(-0.617 -1.236)",
    fill: "#5fad56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigUpArrow);
export default __webpack_public_path__ + "static/media/big-up-arrow.871bdbb5eb5f0ef98a583f5f7a9cc324.svg";
export { ForwardRef as ReactComponent };